const defaultState = {
  user: {},
  error: null,
  fetching: false,
  fetched: false
};

const confirmPasswordReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CONFIRM_PASSWORD_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'CONFIRM_PASSWORD_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, user: action.payload
      };
    }
    case 'CONFIRM_PASSWORD_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default confirmPasswordReducer;


// WEBPACK FOOTER //
// ./src/reducers/confirmPassword.js